export const DEFAULT = "default";
export const MODAL_ONLY = "only";
